// extracted by mini-css-extract-plugin
module.exports = {"logoText":"styles_logoText__7Mjuv","logoPosition":"styles_logoPosition__Gs__I"};